/**
 * Unified Knowledge Search API service
 */

import { apiClient } from './client';

// Access auth store via global to avoid circular dependency
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getAuthStore = () => (window as any).__NEOKANBAN_AUTH_STORE__;

// Helper to get organization ID for query params
const getOrgId = (): string => {
  const { currentOrgId } = getAuthStore().getState();
  if (!currentOrgId) {
    throw new Error('No organization selected');
  }
  return currentOrgId;
};

// ===================================================================
// Types
// ===================================================================

export interface UnifiedSearchResult {
  source: string;
  entity_type: string;
  entity_id: string;
  title: string;
  snippet: string;
  relevance_score: number;
  metadata: Record<string, unknown>;
}

export interface UnifiedSearchResponse {
  query: string;
  results: UnifiedSearchResult[];
  total_count: number;
  took_ms: number;
  sources_searched: string[];
  source_counts: Record<string, number>;
}

export interface UnifiedSearchOptions {
  entity_types?: string[];
  context_type?: string;
  context_id?: string;
  limit?: number;
}

// ===================================================================
// API Methods
// ===================================================================

export const searchApi = {
  /**
   * Perform a unified knowledge search across all entity types
   */
  unifiedSearch: async (
    query: string,
    options?: UnifiedSearchOptions,
  ): Promise<UnifiedSearchResponse> => {
    const response = await apiClient.post<UnifiedSearchResponse>(
      '/chat/search/unified',
      {
        query,
        entity_types: options?.entity_types,
        context_type: options?.context_type,
        context_id: options?.context_id,
        limit: options?.limit ?? 20,
      },
      {
        params: { organization_id: getOrgId() },
      },
    );
    return response.data;
  },
};
